import i18next from 'i18next';
import type { KorintReactAxiosSetupConfig } from 'korint-sdk/react';

import { config } from './config';
import { defaultErrorMessage, errorDictionary } from './errors';

export const clientOptions = {
  errorTranslatorConfig: {
    dict: errorDictionary,
    defaultErrorMessage: defaultErrorMessage,
    i18n: i18next,
  },
  authConfig: {
    Cognito: {
      userPoolId: config.COGNITO_USER_POOL_ID,
      userPoolClientId: config.COGNITO_USER_POOL_WEB_CLIENT_ID,
      signUpVerificationMethod: 'link' as const,
      loginWith: {
        email: true,
        oauth: {
          domain: 'korint-garantie-plus.auth.eu-west-3.amazoncognito.com',
          responseType: 'code' as const,
          scopes: [
            'openid',
            'profile',
            'email',
            // All korint.io/* feature scopes are granted server-side: this scope marks the
            // session as a first-party webapp and the gateway's ScopesGuard then allows every
            // scope in its internalScopes set (same treatment as the aws.cognito.signin.user.admin
            // scope that Cognito stamps on native email/password logins). Future feature scopes
            // therefore require no Cognito/frontend change and no user re-login.
            'korint.io/webapp',
          ],
          providers: ['Google'] as const,
          redirectSignIn: [new URL('/redirect', window.location.origin).toString()],
          redirectSignOut: [window.location.origin],
        },
      },
    },
  },
  tenant: config.TENANT_ID,
  baseUrl: config.KORINT_API_URL,
  postHogKey: config.PUBLIC_POSTHOG_KEY,
} satisfies KorintReactAxiosSetupConfig;
